import currency from 'currency.js'

export const toBarChartData = data =>
  data.reduce((a, item) => {
    if (!a.totalCount) {
      a.totalCount = item.count
    } else {
      a.totalCount = a.totalCount + item.count
    }

    if (!a.totalValue) {
      a.totalValue = currency(item.value).value
    } else {
      a.totalValue = currency(a.totalValue).add(item.value).value
    }

    if (!a.stackedBarByValue) {
      a.stackedBarByValue = {
        [item.user]: currency(item.value).value
      }
    } else {
      if (a.stackedBarByValue[item.user]) {
        a.stackedBarByValue[item.user] = currency(a.stackedBarByValue[item.user]).add(
          item.value
        ).value
      } else {
        a.stackedBarByValue[item.user] = currency(item.value).value
      }
    }

    if (!a.stackedBarByCount) {
      a.stackedBarByCount = {
        [item.user]: item.count
      }
    } else {
      if (a.stackedBarByCount[item.user]) {
        a.stackedBarByCount[item.user] = a.stackedBarByCount[item.user] + item.count
      } else {
        a.stackedBarByCount[item.user] = item.count
      }
    }

    if (!a.keys) {
      a.keys = [item.dealStatusName]
    } else {
      if (!a.keys.includes(item.dealStatusName)) {
        a.keys.push(item.dealStatusName)
      }
    }

    if (!a.users) {
      a.users = [item.user]
    } else {
      if (!a.users.includes(item.user)) {
        a.users.push(item.user)
      }
    }

    if (!a.barByValue) {
      a.barByValue = [
        {
          user: item.user,
          [item.dealStatusName]: currency(item.value).value
        }
      ]
    } else {
      const userNamesArr = a.barByValue.map(c => c.user)
      if (userNamesArr.includes(item.user)) {
        const index = userNamesArr.findIndex(c => c === item.user)
        a.barByValue[index][item.dealStatusName] = currency(item.value).value
      } else {
        a.barByValue.push({
          user: item.user,
          [item.dealStatusName]: currency(item.value).value
        })
      }
    }

    if (!a.barByCount) {
      a.barByCount = [
        {
          user: item.user,
          [item.dealStatusName]: item.count
        }
      ]
    } else {
      const userNamesArr = a.barByCount.map(c => c.user)
      if (userNamesArr.includes(item.user)) {
        const index = userNamesArr.findIndex(c => c === item.user)
        a.barByCount[index][item.dealStatusName] = item.count
      } else {
        a.barByCount.push({
          user: item.user,
          [item.dealStatusName]: item.count
        })
      }
    }

    return a
  }, {})

export const toTable = data =>
  data.reduce((a, item) => {
    item = { ...item }
    if (!a.length) {
      a.push(item)
    } else {
      const userNamesArr = a.map(c => c.user)
      if (userNamesArr.includes(item.user)) {
        const index = userNamesArr.findIndex(c => c === item.user)
        a[index].count = a[index].count + item.count
        a[index].value = currency(a[index].value).add(item.value).value
        a[index].valuePercentage = currency(a[index].valuePercentage).add(
          item.valuePercentage
        ).value
      } else {
        a.push(item)
      }
    }

    return a
  }, [])

export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))
